import { getLeFEOrigin } from '@utils/util';

export const IncomeNewManagerLeFE = () => (
    <iframe className="admin-iframe" title="来款管理(新)" src={`${getLeFEOrigin()}/#/app/admin/bank_bill`} />
);
